module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/LA-Juvie-Yard2_BW-p-1080-e7181e92a7e7af4522f00df1133c403f.jpg";